import {
  REQUEST_RESULTS,
  RECEIVE_RESULTS,
  RECEIVE_MORE_RESULTS,
} from "./actionTypes";

const initialState = {
  isLoading: false,
  isInitialised: false,
};

export const results = (state = initialState, action) => {
  if(action.type === REQUEST_RESULTS){
    return {
      ...state,
      isLoading: !action.isLoadingMore,
      isLoadingMore: action.isLoadingMore,
    }
  }
  else if(action.type === RECEIVE_RESULTS){
    return {
      ...state,
      isLoading: false,
      isLoadingMore: false,
      isInitialised: true,
      data: action.payload.results,
      query: action.payload.query,
    }
  }
  else if(action.type === RECEIVE_MORE_RESULTS){
    return {
      ...state,
      isLoading: false,
      isLoadingMore: false,
      data: {
        ...state.data,
        results: {
          ...state.data.results,
          items: state.data.results.items.concat(action.payload.results.items),
        },
      },
    }
  }

  return state;
}